import { useState } from "react";
import { ContentCardModel } from "atoms/models";
import Accordion from "react-bootstrap/Accordion";
import Card from "./Card";

const HiddenProducts: React.FC<{ hiddenContent: Array<ContentCardModel> }> = ({ hiddenContent }) => {
  const [accordionOpen, setAccordionOpen] = useState(false);

  const toggleAccordion = () => {
    setAccordionOpen(!accordionOpen);
    if (accordionOpen) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="d-flex justify-content-center">
      <div>
        <Accordion activeKey={accordionOpen ? "0" : ""}>
          <Accordion.Item eventKey="0">
            <Accordion.Body>
              <div>
                <div className="mb-5 text-center">
                  <h3>Additional Packages</h3>
                  <hr />
                </div>
                <div
                  className={
                    Array.isArray(hiddenContent) && hiddenContent.length === 2 ? "featured-cards-container-two-products" : "featured-cards-container"
                  }
                >
                  {Array.isArray(hiddenContent) && hiddenContent.length > 0
                    ? hiddenContent.map((card: any, index: number) => (
                        <div className="featured-card" key={index} id={card.bundleDescription ? `bundleId: ${card.id}` : `productId: ${card.id}`}>
                          <Card key={card.id} card={card} />
                        </div>
                      ))
                    : null}
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="d-flex justify-content-center">
          {Array.isArray(hiddenContent) && hiddenContent.length === 0 ? null : (
            <h4 className="view-all-button-label" onClick={toggleAccordion}>
              {accordionOpen ? "VIEW SUGGESTED PLANS" : "ADDITIONAL PLANS"}
            </h4>
          )}
        </div>
      </div>
    </div>
  );
};
export default HiddenProducts;
